import { render, staticRenderFns } from "./RatingBadge.vue?vue&type=template&id=1396bc7e&"
import script from "./RatingBadge.vue?vue&type=script&lang=js&"
export * from "./RatingBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports